import { isError } from 'lodash-es';
import { parseTags } from './utils';
import { ErrorLevel, TagsType } from './types';

/**
 * normalize error info
 * @param level
 * @param label
 * @param description
 * @param error
 * @param tags
 */
export enum HybridSlardarErrorType {
  MISS_SLARDAR_INSTANCE,
}

export const errorHandler = (
  defaultLevel: ErrorLevel,
  label: string,
  description: string,
  err: Error = new Error(''),
  defaultTags: TagsType = {},
  // eslint-disable-next-line max-params
) => {
  let error: any = err;
  const content = error.message as string;

  const level: ErrorLevel = defaultLevel; // error level, default to info
  const reason = content; // error detail msg
  const extra: Record<string, string> = {
    ...parseTags(defaultTags),
    content,
  }; // error extra key-value object

  if (!isError(err)) {
    error = new Error(JSON.stringify(err));
  }

  extra.level = level;

  return {
    level,
    label,
    description,
    reason,
    error,
    extra,
  };
};
